import React from 'react';

import styles from "./textSection.module.scss";
import { renderWithBreaks } from '@utils/translations';

const TextSection = ({ title, text }) => (
  <div className={styles.textSection}>
    <h2>{title}</h2>
    <div>{renderWithBreaks(text)}</div>
  </div>
);

export default TextSection;
